export default "__VITE_ASSET__BjEB4cx2__"